import React from 'react'
import { Bar, BarChart, CartesianGrid, Cell, Legend, Line, LineChart, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { AuthConsole } from '../../Utils/helper';
const COLORS = [
    '#0088FE', '#00C49F', '#FFBB28', '#FF8042',
    '#A28FD0', '#FF6384', '#36A2EB', '#FF9F40',
    '#4BC0C0', '#9966FF', '#C9CBCF', '#2ECC71',
    '#E74C3C', '#F39C12', '#7F8C8D'
]
const getRandomColor = () =>
    `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
  
  // Return color list for your data
  const getDynamicColors = (dataLength) => {
    const colors = [...COLORS];
    while (colors.length < dataLength) {
      colors.push(getRandomColor());
    }
    return colors;
  }
const CompanyInsightCharts = ({ data, Graph }) => {
    AuthConsole(data);
    

    const colors=getDynamicColors(data.length)
    if(!data || data.length==0){
        return(
            <div style={{ textAlign: "center", padding: "2rem", fontWeight: "500", color: "#666" }}>
            No Insights Found
          </div>
        )
    }
    
  return (
    <ResponsiveContainer width="100%" height={300}>
        {Graph=="Pie Chart" &&(
        <PieChart>

            <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%" cy="50%"
            outerRadius={100}
            label>
                {data.map((entry,index)=>(
                    <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}                
            </Pie>

            <Tooltip/>
            <Legend/>
        </PieChart>
    )}
        {Graph=="Line Chart"&&(
        <LineChart data={data}>

            <CartesianGrid strokeDasharray="3 3"/>
            <XAxis dataKey="name"/>
            <YAxis/>
            <Tooltip/>
            <Legend/>
            <Line
                type="monotone"
                dataKey="value"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
            />
        </LineChart>
        )}
        {Graph=="Bar Chart"&&(


        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Legend />
          <Bar dataKey="value" nameKey="name">
          {data.map((entry,index)=>(
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
          </Bar>
        </BarChart>
        )}

    </ResponsiveContainer>
  )
}

export default CompanyInsightCharts